/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliverFeeGradeAmountRespVo
 */
export interface GetDeliverFeeGradeAmountRespVo {
    /**
     * 用户等级编号
     * @type {number}
     * @memberof GetDeliverFeeGradeAmountRespVo
     */
    gradeId?: number;
    /**
     * 起始金额
     * @type {number}
     * @memberof GetDeliverFeeGradeAmountRespVo
     */
    startAmount?: number;
    /**
     * 步长金额
     * @type {number}
     * @memberof GetDeliverFeeGradeAmountRespVo
     */
    stepSizeAmount?: number;
}

/**
 * Check if a given object implements the GetDeliverFeeGradeAmountRespVo interface.
 */
export function instanceOfGetDeliverFeeGradeAmountRespVo(value: object): value is GetDeliverFeeGradeAmountRespVo {
    return true;
}

export function GetDeliverFeeGradeAmountRespVoFromJSON(json: any): GetDeliverFeeGradeAmountRespVo {
    return GetDeliverFeeGradeAmountRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeGradeAmountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeGradeAmountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'startAmount': json['startAmount'] == null ? undefined : json['startAmount'],
        'stepSizeAmount': json['stepSizeAmount'] == null ? undefined : json['stepSizeAmount'],
    };
}

export function GetDeliverFeeGradeAmountRespVoToJSON(json: any): GetDeliverFeeGradeAmountRespVo {
    return GetDeliverFeeGradeAmountRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeGradeAmountRespVoToJSONTyped(value?: GetDeliverFeeGradeAmountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'startAmount': value['startAmount'],
        'stepSizeAmount': value['stepSizeAmount'],
    };
}

